import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable()
export class AuthGuard  {
 constructor(private router: Router) { }

 isLoggedIn(){
  if (localStorage.getItem('currentUser')) {
   return true;
  } else{
   return false;
  }
 }

 getAuthorizationToken(){
  var applicationUser = JSON.parse(localStorage.getItem("currentUser"));
  return applicationUser.AuthWebToken;
 }

 canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  
  if (localStorage.getItem('currentUser')) {
   return true;
  }
  this.router.navigate(['/login-register'], { queryParams: { returnUrl: state.url }});
  return false;
 }
}